import { render, staticRenderFns } from "./BoatCallModal.vue?vue&type=template&id=b052cd30"
import script from "./BoatCallModal.vue?vue&type=script&lang=js"
export * from "./BoatCallModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports